import { types } from 'mobx-state-tree';

export const ThreeSettings = types
  .model('ThreeSettings', {
    castShadow: types.optional(types.boolean, true),
    dpr: types.optional(types.number, window.devicePixelRatio),
  })
  .actions((self) => ({
    setCastShadow(v: boolean) {
      self.castShadow = v;
    },
    setDpr(v: number) {
      self.dpr = v;
    },
  }));

export const DisplaySettings = types
  .model('DisplaySettings', {
    vehicleType: types.optional(
      types.enumeration(['skateboard', 'scooter', 'bike', 'custom']),
      'skateboard'
    ),
    showTrajectory: types.optional(types.boolean, true),
    showGround: types.optional(types.boolean, true),
    showGroundMesh: types.optional(types.boolean, false),
    showGForce: types.optional(types.boolean, false),
    activateAutoEstimate: types.optional(types.boolean, true),
    weatherUnits: types.optional(
      types.enumeration(['metric', 'imperial']),
      'metric'
    ),
    defaultViewMode: types.optional(
      types.enumeration(['score', 'runstats']),
      'score'
    ),
    estimatorUrl: types.optional(types.string, ''),
    serverUrl: types.optional(types.string, ''),
      downloadType: types.optional(
        types.enumeration([
          'all',
          'only_video',
          'only_telemetry',
          'only_steps',
          'only_figures',
          'only_details',
        ]),
        'all'
      ),
  })
  .actions((self) => ({
    setVehicleType(type: 'skateboard' | 'scooter' | 'bike' | 'custom') {
      self.vehicleType = type;
    },
    setShowTrajectory(show: boolean) {
      self.showTrajectory = show;
    },
    setShowGround(show: boolean) {
      self.showGround = show;
    },
    setShowGroundMesh(show: boolean) {
      self.showGroundMesh = show;
    },
    setShowGForce(show: boolean) {
      self.showGForce = show;
    },
    setActivateAutoEstimate(active: boolean) {
      self.activateAutoEstimate = active;
    },
    setWeatherUnits(units: 'metric' | 'imperial') {
      self.weatherUnits = units;
    },
    setDefaultViewMode(mode: 'score' | 'runstats') {
      self.defaultViewMode = mode;
    },
    setEstimatorUrl(url: string) {
      self.estimatorUrl = url;
    },
    setServerUrl(url: string) {
      self.serverUrl = url;
    },
      // removed: setDownloadImuData, setDownloadStats, setDownloadVideo
    setDownloadType(type: 'only_video' | 'only_telemetry' | 'only_steps' | 'only_figures' | 'only_details' | 'all') {
      self.downloadType = type;
    },
  }));

export const AppDataModel = types
  .model({
    onboardingCompleted: types.maybe(types.Date),
    threeSettings: types.optional(ThreeSettings, {}),
    displaySettings: types.optional(DisplaySettings, {}),
  })
  .actions((self) => ({
    completeOnboarding(date?: Date) {
      self.onboardingCompleted = date || new Date();
    },
  }));

export const appData = AppDataModel.create({});

export default AppDataModel;
